import React, { useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Row,
  Col,
} from "antd";
import { useSelector } from "react-redux";

const { Option } = Select;

const EditForm = ({ equipment, form }) => {
  const categories = useSelector((state) => state.equipmentCategories.data);
  const brands = useSelector((state) => state.equipmentBrands.data);
  useEffect(() => {
    form.resetFields();
  }, [equipment, form]);
  return (
    <Form
      form={form}
      layout="vertical"
      name="editEquipment"
      initialValues={equipment}
    >
      <Form.Item
        name="category"
        label="Category"
        rules={[
          { required: true, message: "Please select or enter a category!" },
        ]}
      >
        <Select style={{ width: "100%" }} placeholder="Select a category">
          {categories.map((category) => (
            <Option key={category} value={category}>
              {category}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="brand"
        label="Brand"
        rules={[{ required: true, message: "Please input the brand!" }]}
      >
        <Select style={{ width: "100%" }} placeholder="Select a brand">
          {brands.map((brand) => (
            <Option key={brand} value={brand}>
              {brand}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="model"
        label="Model"
        rules={[{ required: true, message: "Please input the model!" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="price"
        label="Price"
        rules={[{ required: false, message: "Please input the price!" }]}
      >
        <Input
          addonBefore="$"
          placeholder="Enter price"
          type="number"
          min={0}
          step={0.01}
        />
      </Form.Item>
      <Form.Item
        name="partNumber"
        label="Part Number"
        rules={[{ required: false, message: "Please input the part number!" }]}
      >
        <Input />
      </Form.Item>
      {/* next two form items are on the same line */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="orderableItem"
            valuePropName="checked"
            rules={[{ required: false }]}
          >
            <Checkbox>Orderable Item</Checkbox>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="calibrationAvailable"
            valuePropName="checked"
            rules={[{ required: false }]}
          >
            <Checkbox>Calibration Available</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default EditForm;
